import { z } from 'zod';

export const preQualifySchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  companyName: z.string().min(1, 'Business name is required'),
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Please enter a valid email address'),
  phone: z.string().min(1, 'Phone number is required'),
  itContactEmail: z
    .string()
    .min(1, 'IT contact email is required')
    .email('Please enter a valid email address'),
  productRequest: z.string().min(1, 'Product selection is required'),
  primaryPms: z.string().min(1, 'PMS system selection is required'),
  imagingPlatform: z.string().min(1, 'Imaging system selection is required'),
});
